export default "__VITE_ASSET__3699e807__"